module.exports = __webpack_public_path__ + "img/logo-new-top.min.1d4bc8f1.svg";